// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"bd6cd130","202":"4e36e4f2","209":"4b3493f7","230":"6ce11d0e","347":"13f908c0","385":"dcbf728a","551":"1e3cb0c4","556":"19566948","565":"b5d6c584","811":"0ebb7c98","901":"a0c1eee2","929":"c7e50993","956":"4e2f8032"}[chunkId] + ".chunk.js";
};